import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const isotherm = {
    jpath: ['spectra', 'isotherm'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default isotherm;
//# sourceMappingURL=isotherm.js.map